export default __webpack_public_path__ + "static/media/banner-image.29828ac7.svg";